/**
 * @file 無料登録
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname CheckToggle
 * @classdesc お届け先変更
 */
export default class CheckToggle {
	/**
	 * @constructor
	 * @param {jQuery} $e - .check-toggle
	 */
	constructor($e) {
		console.log('CheckToggle.constructor');
		this._$e = $e;
		const target = $e.attr('data-target');
		this._$target = $e.closest('.radio-group').find(target);
		$e.on('click', () => this.onClick());
		this.onClick();
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof CheckToggle
	 * @return {undefined}
	 */
	onClick() {
		console.log('CheckToggle.onClick');
		if(this._$e.prop('checked')){
			this._$target.show().find('.validate').removeClass('ignore-validate');
		}else{
			Common.addIgnoreValidate(this._$target);
		}
	};
}
